import { TEventBus } from '@eventBus/EventBus';

import { DebuggerEvents } from './Debugger.events';

export type TLifecycleEventReporter = (eventInfo: string) => void;

type TLifecycleEventReporterFactory = (module: string, eventBus: TEventBus) => TLifecycleEventReporter;

export const LifecycleEventReporterFactory: TLifecycleEventReporterFactory = (module, eventBus: TEventBus) => (eventInfo) => {
  eventBus.publish(DebuggerEvents.lifecycleEvent, {
    module,
    eventInfo,
    timestamp: Date.now(),
  });
};
